var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('navbar',{attrs:{"title":"Ares - Leads","home":true,"type":_vm.menuType,"data":_vm.data,"attms":_vm.attms,"notts":_vm.notts,"mails":_vm.mails,"colorChoice":true},on:{"actionClick":_vm.actionClick}}),_c('agentPref',{ref:"agentPref"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }